export default "__VITE_ASSET__CBi_EeiW__"